import { api, setter } from '@/modules/helper';

export default {
  namespaced: true,

  state: {
    auth: {},
    activeCamera: null,
  },

  mutations: {
    dynamicSet: setter,
  },

  getters: {
    auth: state => state.auth,
    activeCamera: state => state.activeCamera,
  },

  actions: {
    login({ dispatch }, payload) {
      return api.post('auth', payload).then(() => dispatch('getMe'));
    },

    logout({ commit }) {
      return api
        .post('auth/logout')
        .then(() => commit('dynamicSet', { auth: {} }));
    },

    getMe({ commit }) {
      return api
        .get('auth')
        .then(auth => commit('dynamicSet', { auth: auth.data }))
        .catch(error => error);
    },

    updatePassword(state, payload) {
      return api.patch('auth/password', payload);
    },

    updateProfile({ dispatch }, payload) {
      return api.patch('auth/profile', payload).then(() => dispatch('getMe'));
    },

    updateActiveCamera({ commit }, payload) {
      commit('dynamicSet', { activeCamera: payload });
    },

    flush({ commit }) {
      commit('dynamicSet', { auth: {} });
    },
  },
};
